interface TermMap {
  [key: string]: {
    healthcare: string;
    default: string;
  };
}

const TERMS_MAP: TermMap = {
  purchaseTerm: {
    healthcare: 'payment',
    default: 'purchase',
  },
  serviceTerm: {
    healthcare: 'treatment',
    default: 'purchase',
  },
  careTerm: {
    healthcare: 'care',
    default: 'service',
  },
  // Add more terms here if needed in the future
};

export const getTermByVerticalType = (termKey: keyof typeof TERMS_MAP, isHealthcareVertical?: boolean): string => {
  if (!TERMS_MAP[termKey]) {
    return '';
  }

  return isHealthcareVertical ? TERMS_MAP[termKey].healthcare : TERMS_MAP[termKey].default;
};
